<nav class="sidenav expanded">
  <div
    [ngClass]="selected === item.name ? 'selected' : ''"
    class="item"    
    [ngStyle]="{'color':item.color, 'border-bottom':'solid', 'font-size':item.font, 'border-color':item.border}" 
    *ngFor="let item of menuItems"
  >
    <button 
      (click)="select(item)" 
      class="item-container"
      [ngClass]="item.name === 'Main Menu' ? 'main-container' : ''"
      tabindex="0"
      [ngStyle]="{'background': selectedSection === item ? item.border :  item.bgcolor || 'white', 'color': selectedSection === item ? 'white' : item.color, 'cursor':item.cursor}"
    >
      <div class="name" [ngClass]="item.name === 'Main Menu' ? 'main' : ''">{{ item.name }}</div>
      <div
        *ngIf="item.items"
        class="expand-button"
        
        [ngClass]="item.expanded ? 'expanded' : ''"
      >
        <svg
          alt=""
          focusable="false"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"
          ></path>
        </svg>
      </div>
    </button>
    <div *ngIf="item.expanded" class="subitems">
      <button
        (keypress)="select(subitem)"
        (click)="select(subitem)"
        *ngFor="let subitem of item.items"
        class="subitem"
        [ngClass]="selected === subitem.route ? 'selected' : ''"    
        tabindex="0"    
      >
        {{ subitem.name }}
    </button>
    </div>
  </div>
</nav>
